/***
 * default prefix 'CARD_UNSAVED_DESCRIPTION'
 */
export const AT_SET = 'CARD_DESCRIPTION_UNSAVED_SET';
export const AT_DELETE = 'CARD_DESCRIPTION_UNSAVED_DELETE';
